import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

const NotFoundContainer = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 120px 0 80px;
  background-color: var(--bg-color);
`;

const NotFoundContent = styled.div`
  max-width: 600px;
  padding: 40px;
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.6s ease-out forwards;
`;

const Code = styled.h1`
  font-size: 6rem;
  margin-bottom: 10px;
  color: var(--secondary-color);
  font-weight: 900;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 576px) {
    font-size: 4rem;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  
  @media (max-width: 576px) {
    font-size: 1.8rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;
  
  @media (max-width: 576px) {
    font-size: 1rem;
  }
`;

const NotFound = () => {
  return (
    <NotFoundContainer>
      <div className="container">
        <NotFoundContent>
          <Code>404</Code>
          <Title>Página Não Encontrada</Title>
          <Description>
            A página que você está procurando pode ter sido removida, 
            renomeada ou está temporariamente indisponível.
          </Description>
          <Link to="/">
            <Button>Voltar para Home</Button>
          </Link>
        </NotFoundContent>
      </div>
    </NotFoundContainer>
  );
};

export default NotFound;
